module.exports = __webpack_public_path__ + "img/jaguar_thumbnail.6705651d.png";